import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'durationFromNow'
})
export class DurationFromNowPipe implements PipeTransform {

  transform(value: string): any {
    if (!value) {
      return '';
    }

    const diff = moment(value).diff(moment());

    const duration = moment.duration(diff);
    return duration.locale('fa').humanize();
  }
}
